import BaseModal              from '../components/BaseModal/index.js';
import { Media, Inline, Alert } from '../components/BaseModal/plugins/index.js';

/**
 * Configure and initialize BaseModal
 */
function modal() {
    const settings = {
        // Triggers and classes
        targetModal  : '',                    // ID of modal to open (programmatic use)
        triggers     : [],                    // Custom trigger elements
        openTrigger  : 'data-basemodal-trigger', // Attribute for open trigger
        closeTrigger : 'data-basemodal-close',   // Attribute for close trigger
        openClass    : 'is-open',              // Class applied to opened modal

        // Behaviour
        disableScroll       : true,                  // Lock page scroll
        disableFocus        : false,                 // Disable focus management
        backFocus           : true,                  // Return focus to opener
        awaitOpenAnimation  : false,                 // Wait for open animation
        awaitCloseAnimation : false,                 // Wait for close animation
        disableEsc          : false,                 // Block Escape close
        allowNested         : true,                  // Allow stacked modals
        autoClose           : false,                 // Enable autoclose timer
        autoCloseDelay      : 3000,                  // Autoclose delay
        lazyLoad            : false,                 // Load content via fetch
        contentUrl          : ' ',                   // URL for lazy content
        position            : 'center',              // top | center | bottom
        theme               : 'light',               // light | dark
        animation           : 'fade',                // fade | zoom | slideUp | slideDown
        size                : 'default',             // small | default | large | fullscreen
        swipeNavigation     : false,                 // Enable swipe navigation
        dragToDismiss       : false,                 // Enable drag to dismiss
        dragThreshold       : 100,                   // Drag threshold px
        hapticFeedback      : false,                 // Vibrate on actions
        pullToRefresh       : false,                 // Pull-to-refresh support

        // Hooks
        onShow          : () => {
        },              // Callback on show
        onClose         : () => {
        },              // Callback on close
        onContentLoaded : () => {
        },              // Callback when lazy content loaded
        onSwipeLeft     : () => {
        },              // Swipe left handler
        onSwipeRight    : () => {
        },              // Swipe right handler
        onRefresh       : () => {
        },              // Pull-to-refresh handler

        // Middleware
        beforeShow  : [],                    // Array of async middleware before show
        beforeClose : [],                    // Array of async middleware before close

        // Keyboard
        keyboardShortcuts : {},                    // Custom keyboard map

        // Debug
        debugMode : false                  // Enable verbose logging
    };

    BaseModal.init(settings);

    // Register plugins
    BaseModal.use(Media, {
        selector                : '[data-basemodal-media]',
        gallery                 : true,
        autoplay                : false,
        loop                    : false,
        controls                : true,
        preload                 : 'metadata',
        loading                 : 'lazy',
        theme                   : 'dark',
        animation               : 'zoom',
        closeOnVideoEnd         : false,
        fullscreen              : false,
        fullscreenButtonContent : '<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'24\' height=\'24\' viewBox=\'0 0 24 24\' fill=\'none\' pointer-events=\'none\'><path d=\'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z\' fill=\'currentColor\'/></svg>',
        showCloseButton         : true,
        closeButtonContent      : '&times;',
        showOverlay             : true,
        showCounter             : true,
        debugMode               : false,
        locales                 : {
            close       : 'Close',
            fullscreen  : 'Toggle Fullscreen',
            prev        : 'Previous',
            next        : 'Next',
            unsupported : 'Unsupported media type'
        }
    });

    BaseModal.use(Inline, {
        selector           : '[data-basemodal-inline]',
        theme              : 'light',
        animation          : 'zoom',
        size               : 'default',
        showCloseButton    : true,
        closeButtonContent : '&times;',
        showOverlay        : true,
        debugMode          : false,
        locales            : {
            close : 'Close'
        }
    });

    BaseModal.use(Alert, {
        selector             : '[data-basemodal-alert]',
        type                 : 'info',
        theme                : 'light',
        animation            : 'slideUp',
        size                 : 'small',
        autoClose            : 0,
        showIcon             : true,
        iconContent          : ' ',
        icons                : null,
        showTitle            : true,
        title                : ' ',
        showCloseButton      : true,
        closeButtonContent   : '&times;',
        showOverlay          : true,
        showConfirmButton    : false,
        showCancelButton     : false,
        confirmButtonContent : 'OK',
        cancelButtonContent  : 'Cancel',
        onConfirm            : null,
        onCancel             : null,
        debugMode            : false,
        locales              : {
            close   : 'Close',
            info    : 'Info',
            warning : 'Warning',
            error   : 'Error',
            confirm : 'OK',
            cancel  : 'Cancel'
        }
    });
}

export { modal };
